import React from 'react';
import ComingSoon from './ComingSoon';

// This page used to show hard-coded sample revenue and KPIs. Until it is built
// on the real books it says so; the real reports are under Accounting.
export default function ReportsPage() {
  return (
    <ComingSoon
      title="Reports"
      note="Business dashboards are not built yet. Profit & loss, balance sheet, A/R aging and sales reports from your real books are under Accounting → Reports."
      link={{ to: '/app/accounting/reports', label: 'Open Accounting → Reports' }}
    />
  );
}
